import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import Grid from '@material-ui/core/Grid';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Clear from '@material-ui/icons/Clear';
import Skeleton from '@material-ui/lab/Skeleton';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';

import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import MFSMicroserviceAddEdit from './MFSMicroserviceAddEdit';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 450,
  },

  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  dialogButtonSection: {
    padding: '8px 20px',
    justifyContent: 'space-between',
  },
  floatRight: {
    position: 'absolute',
    top: 3,
    right: 3,
  },

  imgStyle: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  container: {
    maxHeight: 'calc(100vh - 230px)',
    overflow: 'auto',
  },

  cellWidth: {
    width: '230px',
  },

  tableHeadStyle: {
    '& th': {
      fontWeight: 600,
      fontSize: '1rem',
      backgroundColor: '#000132',
      color: 'white',
    },
  },

  tableBodyStyle: {
    '& td': {
      padding: '8px 16px',
    },
  },
  detailButton: {
    color: '#C3C8C8',
    // margin: '0 5px',
    // border: '1px solid #C3C8C8',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#F1F1F1' },
  },
  editButton: {
    color: '#00C4B4',
    // margin: '0 5px',
    // border: '1px solid #66BD4E',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#00C4B410' },
  },
  titleStyle: {
    marginBottom: '1rem',
  },
  buttonStyle: {
    borderRadius: '25px',
  },
  dialogStyle: {
    width: '400px',
  },
  alignCenter: {
    textAlign: 'center',
  },
  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}));

const MFSMicroserviceList = () => {
  const classes = useStyles();
  const { glob_pay_admin_auth, logout, login } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [list, setList] = useState([]);
  const [detailViewItem, setDetailViewItem] = useState({});
  const [openDetailView, setOpenDetailView] = useState(false);
  const [editObj, setEditObj] = useState({});
  const [editIndexNo, setEditIndexNo] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [message, setMessage] = useState('There is no data');
  const [loading, setLoading] = useState(false);

  const [addDialog, setAddDialog] = useState(false);

  const openAddDialog = () => {
    setAddDialog(true);
  };
  const closeAddDialog = (event, reason) => {
    if (reason && reason == 'backdropClick') return;

    setAddDialog(false);
  };
  // ==================Delete Dialogue start==============================
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const handleDeleteDialogClickOpen = () => {
    setDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialog(false);
  };
  // ==================Delete Dialogue End==============================
  const handleClickOpenDetailView = () => {
    setOpenDetailView(true);
  };

  const handleCloseDetailView = () => {
    setOpenDetailView(false);
  };

  const handleClickView = item => {
    setDetailViewItem(item);
    handleClickOpenDetailView();
  };

  const getList = async () => {
    setLoading(true);

    await axios
      .get(`/api/v1/public/mfs`)
      .then(function(response) {
        console.log('response', response);
        setList(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response.data.error);
      });
    setLoading(false);
  };
  const getById = async cid => {
    await axios
      .get(`/api/v1/public/mfs/${cid}`)
      .then(function(response) {
        console.log('res', response);
        setEditObj(response.data.data);
        openAddDialog();
      })
      .then()
      .catch(function(error) {
        // handle error
        console.log(error);
        // setMessage(error.response.data.error);
      });
  };
  const handleDelete = async () => {
    console.log('handleDeleteID', deleteId);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .delete(`/api/v1/private/mfs/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function(response) {
        console.log('response', response);
        let newList = list.filter(res => res.id !== deleteId);
        console.log('newList', newList);
        setList(newList);
        setDeleteDialog(false);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };
  const pageLoading = () => {
    let content = [];

    for (let i = 0; i < 5; i++) {
      content.push(
        <TableRow key={i}>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
        </TableRow>,
      );
    }
    return content;
  };
  useEffect(() => {
    getList();
  }, []);

  return (
    <React.Fragment>
      <Grid container alignItems="center" className={classes.titleStyle}>
        <Grid item md={8}>
          <Typography variant="h2">MFS MICROSERVICE LIST</Typography>
        </Grid>
        <Grid item md={4} style={{ textAlign: 'right' }}>
          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={openAddDialog}
            startIcon={<AddIcon />}>
            Add New
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={12}>
          <TableContainer component={Paper} className={classes.container}>
            <Table stickyHeader aria-label="simple table">
              <TableHead className={classes.tableHeadStyle}>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell align="center">Image</TableCell>

                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center" className={classes.cellWidth}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={classes.tableBodyStyle}>
                {list.length > 0
                  ? list.map((row, i) => (
                      <TableRow hover key={i}>
                        <TableCell scope="row">{row.name}</TableCell>
                        <TableCell align="center">
                          <img src={row.logo} alt="" height="30px" />
                        </TableCell>

                        <TableCell align="center">
                          <img src={row.status ? '/images/ok6.svg' : '/images/cross6.svg'} alt="" height="20px" />
                        </TableCell>
                        <TableCell align="center">
                          <IconButton className={classes.detailButton} onClick={() => handleClickView(row)}>
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton
                            className={classes.editButton}
                            onClick={() => {
                              setEditIndexNo(i);
                              getById(row.id);
                              // openAddDialog();
                              // setEditObj(row);
                            }}>
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            color="secondary"
                            onClick={() => {
                              handleDeleteDialogClickOpen();
                              setDeleteId(row.id);
                            }}>
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  : null}

                {!loading && list.length < 1 ? (
                  <TableRow>
                    <TableCell colSpan="4" style={{ textAlign: 'center' }}>
                      {message}
                    </TableCell>
                  </TableRow>
                ) : null}
                {loading && pageLoading()}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        {/* <Grid item md={4}>
          <Paper className={classes.paper}>
            <MFSMicroserviceAddEdit
              list={list}
              setList={setList}
              editObj={editObj}
              setEditObj={setEditObj}
              editIndexNo={editIndexNo}
              refresh={refresh}
              setRefresh={setRefresh}
            />
          </Paper>
        </Grid> */}
      </Grid>

      <div>
        <Dialog
          open={openDetailView}
          onClose={handleCloseDetailView}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent>
            {detailViewItem ? (
              <TableContainer style={{ marginBottom: '40px' }}>
                <div className={classes.titleDiv}>
                  <div className={classes.iconDiv}>
                    <IconButton
                      style={{ background: 'gainsboro' }}
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={handleCloseDetailView}>
                      <Clear fontSize="inherit" />
                    </IconButton>
                  </div>

                  <Typography variant="h1" className={` ${classes.alignCenter}`}>
                    Details
                  </Typography>
                </div>
                <Table className={classes.table} aria-label="simple table">
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan="2" scope="row" style={{ paddingTop: '0px' }}>
                        <img
                          src={detailViewItem.logo ? detailViewItem.logo : ''}
                          alt=""
                          // width="80px"
                          height="80px"
                          className={classes.imgStyle}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Name</TableCell>
                      <TableCell align="right">{detailViewItem.name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Code</TableCell>
                      <TableCell align="right">{detailViewItem.code}</TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Status</TableCell>
                      <TableCell align="right">
                        {detailViewItem.status ? (
                          <Typography variant="h6" style={{ color: 'green' }}>
                            Available
                          </Typography>
                        ) : (
                          <Typography variant="h6" style={{ color: 'red' }}>
                            Not Available
                          </Typography>
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>
      {/* ==================Add Dialog start============================== */}

      <div>
        <Dialog
          open={addDialog}
          onClose={closeAddDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyle}>
            {/* <CountryAddEdit
              list={list}
              setList={setList}
              editObj={editObj}
              setEditObj={setEditObj}
              editIndexNo={editIndexNo}
              refresh={refresh}
              setRefresh={setRefresh}
              closeAddDialog={closeAddDialog}
              addDialog={addDialog}
            /> */}
            <MFSMicroserviceAddEdit
              list={list}
              setList={setList}
              editObj={editObj}
              setEditObj={setEditObj}
              editIndexNo={editIndexNo}
              refresh={refresh}
              setRefresh={setRefresh}
              closeAddDialog={closeAddDialog}
              addDialog={addDialog}
            />
          </DialogContent>
        </Dialog>
      </div>

      {/* ==================Add Dialog End============================== */}
      {/* ==================Delete Dialogue start============================== */}
      <div>
        <Dialog
          open={deleteDialog}
          onClose={handleDeleteDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: {
              minWidth: '400px',
              boxShadow: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingBottom: '20px',
            },
          }}>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography variant="h3">Are you sure to delete?</Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteDialogClose} variant="outlined">
              Cancel
            </Button>
            <Button color="secondary" onClick={handleDelete} autoFocus variant="contained">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      {/* ==================Delete Dialogue End============================== */}
    </React.Fragment>
  );
};

export default MFSMicroserviceList;
